<template>
    <div>
      <div class="text-orange"><slot name="text-orange"></slot></div>
    </div>
</template>

<script>
    export default {
        name: "HeadLine"
    }
</script>

<style scoped>
.text-orange{
  font-size:36px;
  color: #f39800;
  font-family: '微软雅黑';
  margin-bottom: 60px;
}
.text-orange span{
  font-size: 20px;
  color: #999;
  font-family: '思源黑体';
  text-transform: uppercase;
  font-weight: 100;
  display: block;
  margin-top: 5px;
}

@media only screen and (max-width:767px) {
  .text-orange{
    font-size: 20px;
    margin-bottom: 16px;
  }
  .text-orange span{
    margin-top: 0;
    font-size: 14px;
  }
}
@media only screen and (min-width:768px) {

}
@media only screen and (min-width:992px) {

}
@media only screen and (min-width:1200px) {

}

</style>



// WEBPACK FOOTER //
// src/components/content/headline/HeadLine.vue